import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=6cf2bf7c&"
import script from "./Confirm.vue?vue&type=script&lang=js&"
export * from "./Confirm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/font.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/content.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/musicManagement.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports